import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../scss/components/DatePicker.scss';
import cx from 'classnames';
import moment from 'moment';

const DatePicker = (props) => {

	const handleChange = (date, event) => {
		const momentDate = moment(date, "MM-DD-YYYY", true);
		if (date && momentDate.isValid()) {
			props.onChange(momentDate.toDate());
		} else {
			props.onChange(null);
		}
	};

	const handleOnBlur = (date, event) => {
		props.onBlur(date);
	};

	const handleDateOffset = (stringDate) => {
		// converting to a moment date first prevents any weird UTC offset in native JS date objects
		const momentDate = moment(stringDate);
		return new Date(momentDate);
	};

	return (
		<div className={cx('DatePicker', 'form-group')}>
			<div>
				<label htmlFor={props.id}> {props.label} </label>
			</div>
			<ReactDatePicker
				className={cx('form-control', {
					'is-invalid-shift': props.touched && props.invalidMessage, 'is-invalid': props.touched && props.invalidMessage
				})}
				name={props.name}
				id={props.id}
				isClearable={true}
				selected={props.value ? new Date(props.value) : null}
				placeholderText='mm/dd/yyyy'
				openToDate={props.openToDate ? handleDateOffset(props.openToDate) : props.placeholderText}
				onChange={handleChange}
				onBlur={handleOnBlur}
				onChangeRaw={(event) => handleChange(event.target.value)}
				selectsStart={props.selectsStart === true ? true : undefined}
				selectsEnd={props.selectsEnd === true ? true : undefined}
				startDate={props.startDate ? new Date(props.startDate) : undefined}
				endDate={props.endDate ? new Date(props.endDate) : undefined}
				minDate={props.minSelectDate}
				maxDate={props.maxSelectDate}
			/>
		<div className='form-control is-invalid d-none'></div>
		{props.touched && props.invalidMessage &&
			<div className='invalid-feedback' id={`${props.id}-errorMessage`}>{props.invalidMessage}</div>
		}
		</div>
	);
};

DatePicker.propTypes = {
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	]),
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	id: PropTypes.string.isRequired,
	dateFormat: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	openToDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	]),
	touched: PropTypes.bool,
	invalidMessage: PropTypes.string,
	// Date Range props please see docs https://reactdatepicker.com/#example-20
	selectsStart: PropTypes.bool,
	selectsEnd: PropTypes.bool,
	startDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	]),
	endDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	]),
	placeholderText: PropTypes.string,
	minSelectDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	]),
	maxSelectDate: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.instanceOf(Date)
	])
};

DatePicker.defaultProps = {
	dateFormat: 'MM/DD/YYYY',
	placeholderText: 'mm/dd/yyyy',
	minSelectDate: null,
	maxSelectDate: null
};

export default DatePicker;
